export const getQueryParamValue = (paramName: string) =>
  new URLSearchParams(window.location.search).get(paramName) || undefined;
